import _axios from './_axios'
import BaseConfig from '@/assets/config/URLConfig'
import { Loading } from 'element-ui'

let uploadToken = '';

/*上传图片到七牛云*/
const uploadImg = async (pic) => {
  //上传图片的token
  let token = uploadToken.data.token;     //上传图片token
  pic = (pic.split(','))[1];    //上传的图片base64格式，要去除base64前缀
  return new Promise((resolve, reject) => {
    let url = 'https://upload.qiniup.com/putb64/-1';
    $.ajax({
      method: 'POST',
      url,
      headers: {
        'Authorization': 'UpToken ' + token,
        'Content-Type': 'application/octet-stream'
      },
      data: pic,
      success: res => resolve(res.key),
      error: err => reject(err)
    })
  })
}

/*判断base64图片大小,返回MB单位*/
const showSize = (base64url) => {
  let str = base64url.replace('data:image/png;base64,','');
  let equalIndex = str.indexOf('=');
  if (equalIndex > 0) str = str.substring(0,equalIndex);

  let strLength = str.length;
  let fileLength = parseInt(strLength - (strLength / 8) * 2);
  //由字节转换为MB
  let size = (fileLength / (1024 * 1024)).toFixed(2);
  return Number(size);
}

//base64格式图片压缩,path应该是图片base64码，obj为压缩配置项，可传入图片宽高和压缩的quality值
const canvasDataURL = (path, obj) => {
  return new Promise(resolve => {
    //如果是pdf文件，直接返回pdf文件
    if (path.startsWith('data:application/pdf;')) {
      return resolve(path);
    }
    let img = new Image();
    img.src = path;
    img.onload = function() {
      // 默认按比例压缩
      let w = img.width,
        h = img.height,
        scale = w / h
      w = obj.width || w
      h = obj.height || (w / scale)
      let quality = 0.7  // 默认图片质量为0.7
      //生成canvas
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      // 创建属性节点
      let anw = document.createAttribute('width')
      anw.nodeValue = w
      let anh = document.createAttribute('height')
      anh.nodeValue = h
      canvas.setAttributeNode(anw)
      canvas.setAttributeNode(anh)
      ctx.drawImage(img, 0, 0, w, h)
      // 图像质量
      if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
        quality = obj.quality
      }
      // quality值越小，所绘制出的图像越模糊
      let base64 = canvas.toDataURL('image/jpeg', quality)
      // 返回base64的值
      resolve(base64)
    }
  })
}

// /*对外暴露的上传图片的方法
// * 1、将传入的图片分为base64、七牛云图片地址分别处理
// * 2、对base64图片数组再次处理，过滤出图片大小超过2M的图片并压缩后返回
// * 3、将base64图片数组上传到七牛云，并拿到返回的图片名称
// * 4、将所有的图片七牛云地址返回*/
// export const UploadImages = async (files,join=false) => {
//   //如果没有传入任何值，直接返回空数组
//   if (!files) return [''];
//   // //如果传入的不是数组，则将传入的值推进数组
//   let uploadFiles = [];
//   if (!$.isArray(files)) uploadFiles.push(files);
//   else uploadFiles = files;

//   //将传入的图片分为base64、七牛云图片地址分别处理
//   let base64Arr = [],cdnImgArr = [];
//   let base64str = ';base64,',qnstr = BaseConfig.QINIU_URL;
//   let divide = BaseConfig.IsDevMode ? 'cn/' : 'cn/'
//   uploadFiles.forEach(v => {
//     if (v.indexOf(base64str) !== -1) base64Arr.push(v);             //base64格式的图片
//     else if (v.indexOf(qnstr) !== -1) {
//       let reg2 =  new RegExp('('+BaseConfig.QINIU_URL+')+','g')
//       v = v.replace(reg2,BaseConfig.QINIU_URL)
//       cdnImgArr.push(v.split(divide).pop());
//     }  //带七牛前缀的图片
//     else cdnImgArr.push(v);                                         //不带七牛前缀的图片
//   })

//   // //对base64图片数组进行大小分组处理
//   let bigImg = base64Arr.filter(v => showSize(v) > 2);
//   let valueImg = base64Arr.filter(v => showSize(v) <= 2);

//   let handlePromise = bigImg.map(img => canvasDataURL(img,{}));
//   let resultArr = await Promise.all(handlePromise);
//   base64Arr = valueImg.concat(resultArr);                           //需要上传的base64格式图片
//   let uploadImgs = [];                                              //上传图片以后返回的图片数组
//   if (base64Arr.length > 0) {
//     let loadingInstance = Loading.service({
//       lock: true,
//       text: '图片上传中...',
//       spinner: 'el-icon-loading',
//       background: 'rgba(255, 255, 255, 0.7)',
//     })
//     //获取上传图片的Token
//     uploadToken = await _axios.post('/pc/AuthAndBind/GetQiNiuToken', {});
//     //将处理好大小的base64图片数组上传到七牛云，并拿到返回的名称
//     let handleUpload = base64Arr.map(img => uploadImg(img));
//     uploadImgs = await Promise.all(handleUpload);
//     //拼接上传后的cdn地址和已存在的cdn地址并返回
//     loadingInstance.close();
//   }
//   //判断是否直接返回字符串
//   if(join) return cdnImgArr.concat(uploadImgs).join(',');
//   return  cdnImgArr.concat(uploadImgs);
// };

/*对外暴露的上传图片的方法
* 1、将传入的图片分为base64、七牛云图片地址分别处理
* 2、对base64图片数组再次处理，过滤出图片大小超过2M的图片并压缩后返回
* 3、将base64图片数组上传到七牛云，并拿到返回的图片名称
* 4、将所有的图片七牛云地址返回，【保持原始传入顺序，新上传替换原位】
*/
export const UploadImages = async (files, join = false) => {
  //如果没有传入任何值，直接返回空数组
  if (!files) return [''];
  let uploadFiles = [];
  if (!$.isArray(files)) uploadFiles.push(files);
  else uploadFiles = files;

  const base64str = ';base64,';
  const qnstr = BaseConfig.QINIU_URL;
  const divide = BaseConfig.IsDevMode ? 'cn/' : 'cn/';

  // 1. 先标记每一项：是cdn老图 / base64待上传，保存索引
  const taskList = uploadFiles.map((v, idx) => {
    let isBase64 = v.indexOf(base64str) !== -1;
    let cdnUrl = '';
    if (!isBase64) {
      if (v.indexOf(qnstr) !== -1) {
        const reg2 = new RegExp('(' + BaseConfig.QINIU_URL + ')+', 'g');
        const temp = v.replace(reg2, BaseConfig.QINIU_URL);
        cdnUrl = temp.split(divide).pop();
      } else {
        cdnUrl = v;
      }
    }
    return {
      index: idx,
      raw: v,
      isBase64,
      cdnUrl // 老图的最终cdn值
    };
  });

  // 2. 取出所有base64，做压缩处理（>2M压缩）
  const base64Task = taskList.filter(item => item.isBase64).map(item => item.raw);
  //分组：大于2M、小于等于2M
  const bigImg = base64Task.filter(v => showSize(v) > 2);
  const valueImg = base64Task.filter(v => showSize(v) <= 2);
  //压缩大图
  const compressedList = await Promise.all(bigImg.map(img => canvasDataURL(img, {})));
  // 待上传的base64数组（顺序和bigImg一致）
  const readyUploadBase64 = [...valueImg, ...compressedList];

  // 存放上传结果，key是原始base64字符串，value是上传返回的文件名
  const uploadResultMap = {};
  if (readyUploadBase64.length > 0) {
    const loadingInstance = Loading.service({
      lock: true,
      text: '图片上传中...',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.7)'
    });
    //获取上传图片的Token
    uploadToken = await _axios.post('/pc/AuthAndBind/GetQiNiuToken', {});
    //并发上传，返回顺序和readyUploadBase64一一对应
    const uploadReturnList = await Promise.all(readyUploadBase64.map(img => uploadImg(img)));
    //建立映射：base64 -> 上传后的cdn名称
    readyUploadBase64.forEach((base, i) => {
      uploadResultMap[base] = uploadReturnList[i];
    });
    loadingInstance.close();
  }

  // 3. 【重点】按照原始顺序组装结果
  const finalResult = taskList.map(item => {
    if (item.isBase64) {
      // base64类型，拿上传后的结果回填原位
      return uploadResultMap[item.raw];
    } else {
      // 原本就是cdn地址，直接用
      return item.cdnUrl;
    }
  });

  //判断是否直接返回字符串
  if (join) return finalResult.join(',');
  return finalResult;
};